import { render, staticRenderFns } from "./spam-report-button.vue?vue&type=template&id=558ac2e3&"
import script from "./spam-report-button.vue?vue&type=script&lang=js&"
export * from "./spam-report-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports